"use client";

import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { excellenceFeatures, excellenceStats } from "@/content/excellence";

export function ExcellenceSection() {
  const sectionRef = useRevealOnScroll<HTMLElement>({
    threshold: 0.1,
    staggerInterval: 100,
  });

  return (
    <section
      ref={sectionRef}
      id="excellence"
      className="bg-white py-24 lg:py-32"
    >
      <div className="mx-auto max-w-7xl px-6 lg:px-12">
        {/* Section Header */}
        <div className="reveal mb-20 text-center">
          <div className="text-luxury-green mb-6 inline-flex items-center space-x-3">
            <div className="bg-luxury-green h-0.5 w-12" />
            <span className="text-sm font-semibold tracking-[0.3em] uppercase">
              Наши преимущества
            </span>
            <div className="bg-luxury-green h-0.5 w-12" />
          </div>
          <h2 className="font-display text-luxury-dark mb-6 text-5xl font-bold lg:text-7xl">
            Почему выбирают нас
          </h2>
          <p className="text-luxury-stone mx-auto max-w-3xl text-xl">
            Качество на каждом этапе работы. Более 1000 довольных клиентов —
            наша главная гордость.
          </p>
        </div>

        {/* Features Grid */}
        <div className="grid gap-8 md:grid-cols-2 lg:grid-cols-4">
          {excellenceFeatures.map((feature, index) => (
            <div
              key={feature.title}
              className="reveal text-center"
              style={{ animationDelay: `${index * 0.1}s` }}
            >
              <div className="bg-luxury-green/10 mx-auto mb-6 flex h-20 w-20 items-center justify-center rounded-full">
                <feature.icon className="text-luxury-green h-10 w-10" />
              </div>
              <h3 className="font-display text-luxury-dark mb-4 text-2xl font-bold">
                {feature.title}
              </h3>
              <p className="text-luxury-stone">{feature.description}</p>
            </div>
          ))}
        </div>

        {/* Stats */}
        <div className="reveal mt-20 grid gap-8 md:grid-cols-3">
          {excellenceStats.map((stat) => (
            <div key={stat.label} className="bg-luxury-cream p-8 text-center">
              <p className="font-display text-luxury-green mb-3 text-5xl font-bold">
                {stat.value}
              </p>
              <p className="text-luxury-stone text-lg">{stat.label}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
